import React from 'react';
import { motion } from 'framer-motion';
import { FiShield, FiUsers, FiAward, FiClock, FiGlobe, FiHeart } from 'react-icons/fi';
import { useTranslation } from '../../hooks/useTranslation';
import './WhyChooseUs.css';

const WhyChooseUs = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: FiShield,
      title: t('whyChoose.authentic'),
      description: t('whyChoose.authenticDesc')
    },
    {
      icon: FiUsers,
      title: t('whyChoose.astrologers'),
      description: t('whyChoose.astrologersDesc')
    },
    {
      icon: FiAward,
      title: t('whyChoose.trusted'),
      description: t('whyChoose.trustedDesc')
    },
    {
      icon: FiClock,
      title: t('whyChoose.availability'),
      description: t('whyChoose.availabilityDesc')
    },
    {
      icon: FiGlobe,
      title: t('whyChoose.global'),
      description: t('whyChoose.globalDesc')
    },
    {
      icon: FiHeart,
      title: t('whyChoose.confidential'),
      description: t('whyChoose.confidentialDesc')
    }
  ];
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5 }
    }
  };

  return (
    <section className="why-choose-section section">
      <div className="container">
        <div className="section-title">
          <h2>{t('whyChoose.title')}</h2>
          <p>{t('whyChoose.subtitle')}</p>
        </div>

        <motion.div
          className="features-grid"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-50px" }}
        >
          {features.map((feature, index) => (
            <motion.div key={index} className="feature-card" variants={itemVariants}>
              <div className="feature-icon">
                <feature.icon />
              </div>
              <h4>{feature.title}</h4>
              <p>{feature.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
